import { Phone, Siren } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES } from "../../data/content";

export const EmergencyBanner = () => (
  <section className="relative overflow-hidden" data-testid="emergency-banner">
    <div className="absolute inset-0">
      <img src={IMAGES.emergency} alt="Car at night on Las Vegas roadside" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/80" />
    </div>
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 sm:py-24 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
      <div>
        <div className="inline-flex items-center gap-2 text-red-500 mb-4">
          <Siren className="h-5 w-5" />
          <span className="text-xs font-bold uppercase tracking-[0.2em]">Emergency Roadside Assistance</span>
        </div>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mb-3">
          Broken down right now?
        </h2>
        <p className="text-zinc-300 max-w-xl leading-relaxed">
          Dead battery, no-start, overheating on the freeway — don't wait hours for a tow.
          Call now and we'll get to you fast, anywhere in the valley.
        </p>
      </div>
      <a
        data-testid="emergency-call-button"
        href={PHONE_TEL}
        className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-8 py-5 font-heading font-bold text-lg transition-colors shrink-0"
      >
        <Phone className="h-6 w-6" /> {PHONE_DISPLAY}
      </a>
    </div>
  </section>
);
